export enum TrafficReportType {
  ALTERNATIVE_ROUTING = 'AlternativeRouting',
  BARRIER = 'Barrier',
  CONSTRUCTION_WORKS = 'ConstructionWorks',
  DIVERSION = 'Diversion',
  ENVIRONMENTAL_OBSTRUCTION = 'EnvironmentalObstruction',
  MAINTENANCE_WORKS = 'MaintenanceWorks',
  NATURAL_EVENT = 'NaturalEvent',
  PUBLIC_EVENT = 'PublicEvent',
  TRAFFIC_JAM = 'TrafficJam',
  UNASSIGNABLE = 'Unassignable',
}
